import courseWrapper from 'cccisd-laravel-assignment/dist/components/navigations/courseWrapper';
import moduleNavigation from 'cccisd-laravel-assignment/dist/components/navigations/withModules';

const navigations = [moduleNavigation, courseWrapper];

export default navigations;
